import {ENDPOINTS} from '../common/endpoints';
import {ICalendarHoliday} from '../models/Calendar/ICalendarHoliday';
import {baseAPI} from './BaseAPI';

export const calendarAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getCalendarHolidays: build.query<ICalendarHoliday[], number>({
            query: (year) => ({url: ENDPOINTS.CALENDAR.HOLIDAYS, method: 'GET', params: {year, country: 'PL'}}),
            // In-memory session cache; reset with the shared API on logout.
            keepUnusedDataFor: Infinity,
        }),
    }),
});
